import css from './SimpleFastEasyElement.module.css';

export const SimpleFastEasyElement: React.FC = () => (
    <div className={css.container}>
        <span className={css.text}>Simple. Fast. Easy.</span>
    </div>
);
